export type CanvasThemeMode = "light" | "dark";

export interface CanvasHeroImageFields {
  /** @deprecated Use `hero_image_light_url` / `hero_image_dark_url`. */
  hero_image_url?: string;
  hero_image_light_url?: string;
  hero_image_dark_url?: string;
}

function resolveLightHeroImageUrl(
  canvas: CanvasHeroImageFields,
): string | undefined {
  return canvas.hero_image_light_url || canvas.hero_image_url;
}

function resolveDarkHeroImageUrl(
  canvas: CanvasHeroImageFields,
): string | undefined {
  return canvas.hero_image_dark_url;
}

/** Presigned hero/thumbnail URL for the active UI theme. */
export function getCanvasHeroImageUrl(
  canvas: CanvasHeroImageFields | undefined,
  mode: CanvasThemeMode,
): string | undefined {
  if (!canvas) {
    return undefined;
  }

  const themedUrl =
    mode === "dark"
      ? resolveDarkHeroImageUrl(canvas)
      : resolveLightHeroImageUrl(canvas);

  return themedUrl || resolveLightHeroImageUrl(canvas);
}
